export const buildInfo = {
    buildDate: "Thu, 13/11/2025",
    buildTime: "21:06:36",

    sourceTag: "release-202510-1-hotfix-2",
    sourceDate: "Thu, 13 Nov 2025 13:28:13 +0800",
    sourceBranch: "master",
    sourceHash: "7f4ef88e13b4e8f87ae8d2c6eb79b2aae3ec4492",
};
